//Polyfill startsWith for IE
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

function Message(text) {
    this.text = text;
}

angular
    .module("common-services", ["ngMaterial", "ngMessages", "ui.router", "ngAnimate", "angular-locker", "angular-google-analytics"])
    .config(function(AnalyticsProvider, GoogleAnalyticsConfig) {
        if (GoogleAnalyticsConfig.Account != "NOT-USED") {
            AnalyticsProvider.setAccount(GoogleAnalyticsConfig.Account).trackPages(true);
        }
    })
    .run([
        "Analytics",
        "$transitions",
        "$location",
        function(Analytics, $transitions, $location) {
            $transitions.onSuccess({}, function(transition) {
                Analytics.trackPage($location.path());
            });
        }
    ])
    .constant("appProduct", {
        name: "common"
    })
    .factory("logTimeTaken", function() {
        var logTimeTaken = {
            request: function(config) {
                config.requestTimestamp = new Date().getTime();
                return config;
            },
            response: function(response) {
                response.config.responseTimestamp = new Date().getTime();
                return response;
            }
        };
        return logTimeTaken;
    })
    .factory("preventTemplateCache", function(app_env, $templateCache) {
        var templateCache = {
            request: function(request) {
                // If the request is a get and the request url is not in $templateCache
                if (request.method === "GET" && request.url.indexOf(".html") !== -1 && $templateCache.get(request.url) === undefined) {
                    var versionNumber = app_env.version.replace(/\./g, "_");
                    request.url = request.url + "?v=" + versionNumber;
                }

                return request;
            }
        };
        return templateCache;
    })
    .config(function($httpProvider) {
        $httpProvider.interceptors.push("logTimeTaken");
        $httpProvider.interceptors.push("preventTemplateCache");
    })
    .provider("service", function() {
        var activeService = {};

        this.setService = function(serviceId, serviceName) {
            activeService = {
                Id: serviceId,
                Name: serviceName
            };
        };

        this.$get = function() {
            return activeService;
        };
    })
    .config(function($mdIconProvider) {
        //https://github.com/nkoterba/material-design-iconsets
        $mdIconProvider
            .iconSet("action", "../assets/icon-sets/action-icons.svg", 24)
            .iconSet("alert", "../assets/icon-sets/alert-icons.svg", 24)
            .iconSet("av", "../assets/icon-sets/av-icons.svg", 24)
            .iconSet("communication", "../assets/icon-sets/communication-icons.svg", 24)
            .iconSet("mdi", "../assets/icon-sets/mdi-icons.svg", 24)
            .iconSet("content", "../assets/icon-sets/content-icons.svg", 24)
            .iconSet("device", "../assets/icon-sets/device-icons.svg", 24)
            .iconSet("editor", "../assets/icon-sets/editor-icons.svg", 24)
            .iconSet("file", "../assets/icon-sets/file-icons.svg", 24)
            .iconSet("hardware", "../assets/icon-sets/hardware-icons.svg", 24)
            .iconSet("icons", "../assets/icon-sets/icons-icons.svg", 24)
            .iconSet("image", "../assets/icon-sets/image-icons.svg", 24)
            .iconSet("maps", "../assets/icon-sets/maps-icons.svg", 24)
            .iconSet("navigation", "../assets/icon-sets/navigation-icons.svg", 24)
            .iconSet("notification", "../assets/icon-sets/notification-icons.svg", 24)
            .iconSet("social", "../assets/icon-sets/social-icons.svg", 24)
            .iconSet("risk", "../assets/icon-sets/risk-icons.svg", 60)
            .iconSet("document", "../assets/icon-sets/document-icons.svg", 24)
            .iconSet("toggle", "../assets/icon-sets/toggle-icons.svg", 24);
    })
    .factory("notificationService", function($injector) {
        // $injector is used instead of injecting the $mdToast as this causes a circular reference downstream because $mdToast uses $http (for some bizare reason)
        var notificationService = {};

        notificationService.showActionToast = function(text, actionText, action) {
            var $mdToast = $injector.get("$mdToast");
            var toast = $mdToast
                .simple()
                .content(text)
                .action(actionText)
                .highlightAction(false)
                .hideDelay(0)
                .position("top right");
            $mdToast.show(toast).then(function(response) {
                if (response == "ok") {
                    if (action) {
                        action();
                    }
                } else if (response == "true") {
                    //alert('Timeout');
                }
            });
        };

        notificationService.showToast = function(text) {
            var $mdToast = $injector.get("$mdToast");
            var toast = $mdToast
                .simple()
                .content(text)
                .hideDelay(10 * 1000)
                .position("top right");

            $mdToast.show(toast);
        };

        notificationService.showTokenTimeoutWarning = function(action) {
            notificationService.showActionToast("Your session is about to expire", "Keep me Logged In", action);
        };

        notificationService.showAuthTimeoutMessage = function() {
            notificationService.showToast("Your Session has Expired and you have been logged out");
        };

        notificationService.showConnectionError = function() {
            var $mdToast = $injector.get("$mdToast");
            $mdToast.show(
                $mdToast
                    .simple()
                    .content("There was an error connecting to the server.  Please check your internet connection and try again.")
                    .position("top right")
                    .hideDelay(3 * 1000)
            );
        };

        notificationService.showAccountLocked = function() {
            var $mdToast = $injector.get("$mdToast");
            $mdToast.show(
                $mdToast
                    .simple()
                    .content("Your user account may be locked out.  Please contact support.")
                    .position("top right")
                    .hideDelay(3 * 1000)
            );
        };

        return notificationService;
    })
    .factory("authenticationService", function(
        $rootScope,
        $location,
        app_env,
        $http,
        locker,
        $interval,
        notificationService,
        $state,
        $window,
        commonLogService
    ) {
        var loginUrl = app_env.baseUrl + "AUTH/api/authentication/logon";
        var renewTokenUrl = app_env.baseUrl + "AUTH/api/authentication/renewtoken";
        var ntlmUrl = app_env.ntlmAuthUrl + "Logon";

        var gotoLogin = function() {
            var launcherPath = "/launcher-app";

            if (!$window.location.pathname.startsWith(launcherPath)) {
                $window.location.href = $window.location.protocol + "//" + $window.location.host + launcherPath;
            }
        };

        var authService = {};

        authService.login = function(user, completedCallback, failedLoginCallback) {
            var payload = user;
            payload.url = $location.host();

            commonLogService
                .decorateApiPromise($http.post(loginUrl, payload))
                .then(function(response) {
                    var data = response.data;
                    var tkn = JSON.parse(data.Token);
                    locker.put("token", tkn);

                    //console.log('login data',data);
                    completedCallback(data.ResetPassword, data.Code);
                })
                .catch(function(response) {
                    if (response.status === 401) {
                        //Login Failed
                        if (failedLoginCallback) {
                            failedLoginCallback(false);
                        }
                    } else if (response.status === 418) {
                        notificationService.showAccountLocked();
                        if (failedLoginCallback) {
                            failedLoginCallback(false);
                        }
                    } else {
                        console.log("Connection Error", response);
                        notificationService.showConnectionError();

                        if (failedLoginCallback) {
                            failedLoginCallback(true);
                        }
                    }
                });
        };
        authService.loginWithCode = function(code, completedCallback, failedLogin) {
            commonLogService
                .decorateApiPromise($http.post(app_env.baseUrl + "AUTH/v2/logon/code?code=" + code))
                .then(function(response) {
                    var tkn = JSON.parse(response.data.Token);
                    locker.put("token", tkn);

                    completedCallback(response.data.ResetPassword, response.data.Code);
                })
                .catch(function(errorResponse) {
                    failedLogin(errorResponse.status);
                });
        };
        authService.ntlmLogin = function(completedCallback, failedLoginCallback) {
            commonLogService
                .decorateApiPromise(
                    $http.get(ntlmUrl, {
                        withCredentials: true
                    })
                )
                .then(function(response) {
                    console.log("Auto Login Response", response);
                    locker.put("token", response.data);
                    completedCallback(false, null);
                })
                .catch(function(errResponse) {
                    console.log("Auto Login Error Response", errResponse);
                    failedLoginCallback();
                });
        };

        authService.tryPassword = function(pwd) {
            var payload = {
                password: pwd
            };
            return $http.post(app_env.baseUrl + "AUTH/v2/password/validate", payload, authService.getAuthHeader());
        };

        authService.internalLogin = function() {
            var tkn = null;
            return $http({
                method: "GET",
                url: app_env.ntlmAuthUrl + "logon",
                withCredentials: true
            }).then(
                function(response) {
                    tkn = response.data;
                    locker.put("token", tkn);
                    return response;
                },
                function(errorResponse) {
                    return errorResponse;
                }
            );
        };

        authService.pushToken = function(token) {
            var parsedToken = JSON.parse(token);
            locker.put("token", parsedToken);
        };
        authService.renewToken = function() {
            console.log("Trying To Renew Token");
            if (authService.isLoggedIn()) {
                return $http.get(renewTokenUrl, authService.getAuthHeader()).then(
                    function(response) {
                        locker.put("token", response.data);
                        console.log("Token Has been Refreshed");
                    },
                    function(errorData) {
                        console.log("Connection Error", errorData);
                        notificationService.showConnectionError();
                    }
                );
            }
        };
        authService.dropToken = function() {
            locker.empty();
            //locker.forget('token');
        };
        authService.logout = function() {
            authService.dropToken();
            gotoLogin();
        };
        authService.isLoggedIn = function() {
            if (locker.has("token")) {
                var tkn = locker.get("token");
                if (tkn && tkn.identity) {
                    return true;
                }

                console.log("isLoggedIn, FALSE", tkn);
                return false;
            }

            console.log("isLoggedIn, FALSE - No Token In Locker");
            return false;
        };
        authService.getToken = function() {
            if (authService.isLoggedIn()) {
                return locker.get("token");
            } else {
                return null;
            }
        };
        authService.getRoles = function() {
            var tkn = authService.getToken();
            if (tkn && tkn.roles) {
                return tkn.roles;
            } else {
                return [];
            }
        };
        authService.hasRole = function(targets) {
            return authService.getRoles().some(function(role) {
                return targets.indexOf(role) > -1;
            });
        };
        authService.getIdentityName = function() {
            var tkn = authService.getToken();
            if (tkn && tkn.identity && tkn.identity.name) {
                return tkn.identity.name;
            } else {
                return null;
            }
        };
        authService.getAuthHeaderName = function() {
            return "X-FMG-Authorisation";
        };
        authService.getAuthHeaderValue = function() {
            return JSON.stringify(authService.getToken());
        };
        authService.getAuthHeader = function() {
            var config = {};

            config.headers = {};
            config.headers[authService.getAuthHeaderName()] = authService.getAuthHeaderValue();
            return config;
        };

        authService.warnExpire = false;
        authService.expires = null;

        authService.untilExpire = function() {
            if (authService.isLoggedIn() && authService.getToken()) {
                var tkn = authService.getToken();

                var expMoment = moment(tkn.expires);

                var msToExpire = expMoment.diff(moment());
                if (msToExpire < 1000 * 60 * 5 + 200) {
                    //Add 200 ms so its over 5 mins
                    authService.warnExpire = true;
                    authService.renewToken();
                } else {
                    authService.warnExpire = false;
                }
                //console.log('To Expire (ms)',msToExpire);
                authService.expires = moment().to(expMoment);
            }

            return null;
        };
        authService.hasExpired = function() {
            if (authService.isLoggedIn() && authService.getToken()) {
                var tkn = authService.getToken();

                return moment(tkn.expires).isBefore(moment());
            }

            return null;
        };
        authService.expireCheck = function() {
            authService.untilExpire();

            var res = authService.hasExpired();
            if (res === true) {
                authService.logout();
                notificationService.showAuthTimeoutMessage();
                gotoLogin();
            } else if (res === null) {
                //hasExpired will return null if the user is not logged in (i.e. no token)
                gotoLogin();
            }
        };

        authService.getTenantId = function() {
            if (authService.isLoggedIn()) {
                var tok = authService.getToken();
                if (tok) {
                    return tok.tenantId;
                }
            }

            return -1;
        };

        $interval(function() {
            if (!$state || !$state.current || $state.current.name !== "diag") {
                authService.expireCheck();
            }
        }, 30 * 1000);

        return authService;
    })
    .factory("screenBlockService", function($rootScope) {
        var screenService = {};
        screenService.blockScreen = function() {
            $rootScope._pageLoad = true;
        };
        screenService.clearScreen = function() {
            $rootScope._pageLoad = false;
        };
        screenService.isBlocked = function() {
            return $rootScope._pageLoad === true;
        };

        return screenService;
    })
    .factory("tenantSetupService", function($http, $location, app_env, commonLogService) {
        //Calls Security Services which don't require authentication
        var tenantSetupService = {};
        tenantSetupService.activeSettings = null;
        tenantSetupService.getSettings = function() {
            var host = $location.host();
            return commonLogService.decorateApiPromise($http.get(app_env.baseUrl + "AUTH/v2/subdomains/byweb/?webAddress=" + host));
        };
        tenantSetupService.getTenantSettings = function(settingKey) {
            var tenantId = tenantSetupService.activeSettings.TenantId;
            return $http.get(
                app_env.baseUrl +
                    "ORG/odata/CompanySettings/?$filter=TenantId eq " +
                    tenantId +
                    " and GroupName eq '" +
                    settingKey +
                    "' &$select=Key,Value"
            );
        };
        return tenantSetupService;
    })
    .factory("organisationService", function($http, app_env, authenticationService, $q) {
        //Calls Security & Organisation Services which DO require authentication
        var orgService = {};
        orgService.getCurrentUserTenant = function() {
            return $http.get(app_env.baseUrl + "AUTH/api/authentication/tenant/current", authenticationService.getAuthHeader());
        };
        orgService.getCompany = function(companyId) {
            return $http.get(app_env.baseUrl + "ORG/api/company/GetCompanyById/?id=" + companyId, authenticationService.getAuthHeader());
        };
        orgService.getCurrentUserOrg = function() {
            return $http.get(app_env.baseUrl + "ORG/api/company/current/my", authenticationService.getAuthHeader());
        };
        orgService.getProductsOnContract = function(companyId, contractId) {
            return $http.get(
                app_env.baseUrl + "ORG/api/company/" + companyId + "/contracts/" + contractId + "/products",
                authenticationService.getAuthHeader()
            );
        };

        orgService.getMyOrg = function() {
            return $http.get(app_env.baseUrl + "ORG/api/company/current/my", authenticationService.getAuthHeader());
        };

        orgService.getMyOrgWithChildren = function() {
            return $http.get(app_env.baseUrl + "ORG/api/company/current/my/withchildren", authenticationService.getAuthHeader());
        };

        orgService.getOrgChildren = function(orgId) {
            console.log('app_env.baseUrl',app_env.baseUrl+ "ORG/api/company");
            return $http.get(app_env.baseUrl + "ORG/api/company/" + orgId + "/children", authenticationService.getAuthHeader());
        };

        orgService.getMyOrgMap = function(orgId) {
            return $http.get(app_env.baseUrl + "ORG/api/company/current/my/descendantsfull", authenticationService.getAuthHeader());
        };

        orgService.search = function(name) {
            return $http.get(app_env.baseUrl + "ORG/api/company/search?name=" + name, authenticationService.getAuthHeader());
        };

        orgService.fetchPartialTree = function(name, rootCompanyId) {
            var payload = {};
            payload.Name = name;
            payload.RootCompanyId = rootCompanyId;

            return $http.post(app_env.baseUrl + "ORG/api/company/fetchPartialTree", payload, authenticationService.getAuthHeader());
        };

        orgService.AddCompanyLeaf = function(name, knownas, parentCompanyId) {
            var payload = {};
            payload.Name = name;
            payload.KnownAs = knownas;
            payload.ParentCompanyId = parentCompanyId;

            return $http.post(app_env.baseUrl + "ORG/api/company/AddCompanyLeaf", payload, authenticationService.getAuthHeader());
        };
        orgService.list = function() {
            var config = authenticationService.getAuthHeader();
            config.cache = true;
            return $http.get(app_env.baseUrl + "RiskID/api/organisation/list", config);
        };
        orgService.structure = function() {
            var config = authenticationService.getAuthHeader();
            config.cache = true;
            return $http.get(app_env.baseUrl + "RiskID/api/organisation/structure", config);
        };
        orgService.lookup = function(id) {
            return that.list().then(function(response) {
                var org = response.data.find(function(org) {
                    return org.OrganisationId === id;
                });
                return !org ? null : org.OrganisationName;
            });
        };
        orgService.getTopLevelCompanies = function() {
            var config = authenticationService.getAuthHeader();
            return $http.get(app_env.baseUrl + "RiskID/api/organisation/toplevels", config);
        };
        orgService.getSettings = function() {
            var config = authenticationService.getAuthHeader();
            config.cache = true;
            return $http.get(app_env.baseUrl + "RiskID/api/organisation/settings", config);
        };

        return orgService;
    })
    .factory("organisationSettingsService", function($http, app_env, authenticationService) {
        var orgSettingsService = {
            initDone: false
        };

        orgSettingsService.init = function(companyId, groupName) {
            orgSettingsService.companyId = companyId;

            orgSettingsService.onInitPromise = $http
                .get(
                    app_env.baseUrl + "ORG/api/company/" + orgSettingsService.companyId + "/settings/" + groupName,
                    authenticationService.getAuthHeader()
                )
                .then(function(response) {
                    orgSettingsService.settings = response.data;
                    orgSettingsService.initDone = true;
                });
        };

        orgSettingsService.getSettings = function() {
            if (orgSettingsService.initDone) {
                return orgSettingsService.settings;
            } else {
                console.log("orgSettingsService init failed or not completed");
                return null;
            }
        };
        orgSettingsService.getSetting = function(key) {
            if (orgSettingsService.initDone) {
                return _.find(orgSettingsService.settings, function(i) {
                    return i.Key == key;
                });
            } else {
                console.log("orgSettingsService init failed or not completed");
                return null;
            }
        };

        return orgSettingsService;
    })
    //PAC = Product Activation Checker - Checks Which products a given tenant has
    .controller("PAC-Controller", function($rootScope, $scope, service, organisationService, authenticationService, screenBlockService, app_env) {
        screenBlockService.blockScreen();
        $scope.env = app_env.name;

        $rootScope.PAC = {
            activeTenant: null,
            activeTenantCompany: null,
            activeContract: null,
            products: [],
            loaded: false
        };

        $scope.outputProducts = function() {
            console.log("PAC", $rootScope.PAC);
        };

        $scope.hasPacLoaded = function() {
            return $rootScope.PAC.products.loaded === true;
        };

        console.log("PAC-Start");
        //Is User Logged In
        if (authenticationService.isLoggedIn()) {
            console.log("PAC-UserIsLoggedIn");
        } else {
            console.log("PAC-NotLoggedIn");
        }

        $scope.hasReportClaimsRestrictionRole = function() {
            var userRoles = authenticationService.getRoles();
            if (userRoles.find(x => x == 'IM-REPORT-CLAIMS-RESTRICTION') === 'IM-REPORT-CLAIMS-RESTRICTION')
            {
                return true;
            }
            return false;
        };

        $scope.hasUserGotFIMInsurerRole = function() {
            var userRoles = authenticationService.getRoles();                      
            if (userRoles.find(x => x == 'FIM-INSURER') === 'FIM-INSURER')
            {                           
                return true;                
            }
            return false;
        };


        var getCurrentTenant = function() {
            organisationService.getCurrentUserTenant().then(
                function(response) {
                    $rootScope.PAC.activeTenant = response.data;

                    loadTenantOrganisation();
                },
                function(errorResponse) {
                    console.log("PAC-Error-TenantLookup");
                }
            );
        };
        var loadTenantOrganisation = function() {
            organisationService.getCompany($rootScope.PAC.activeTenant.CompanyId).then(
                function(response) {
                    $rootScope.PAC.activeTenantCompany = response.data;

                    findContractForService();
                },
                function(errorResponse) {
                    console.log("PAC-Error-TenantCompanyLookup");
                }
            );
        };
        var findContractForService = function() {
            $rootScope.PAC.activeContract = _.find($rootScope.PAC.activeTenantCompany.CustomerContracts, function(c) {
                return c.Service.ServiceId === service.Id;
            });

            getProductsOnContract();
        };
        var getProductsOnContract = function() {
            organisationService.getProductsOnContract($rootScope.PAC.activeTenant.CompanyId, $rootScope.PAC.activeContract.CustomerContractId).then(
                function(response) {
                    $rootScope.PAC.products = response.data;
                    flatternProducts();

                    $rootScope.PAC.products.loaded = true;
                },
                function(errorResponse) {
                    console.log("PAC-Error-Products");
                }
            );
        };

        //this is used to Recursivly go through all products and subproducts and produce a /map.
        //e.g. /IM/ClaimSummary/Something
        var getPaths = function(parentPath, product) {
            if (!product) {
                return [];
            }
            var paths = [];
            var newParentPath = parentPath + "/" + product.Name;
            paths.push(newParentPath);

            _.each(product.SubProducts, function(p) {
                paths.push(getPaths(newParentPath, p));
            });

            return paths;
        };

        var flatternProducts = function() {
            var paths = _.map($rootScope.PAC.products, function(i) {
                return getPaths("", i);
            });

            var flatPaths = _.flattenDeep(paths);

            $rootScope.PAC.flatProducts = flatPaths;
            completedPAC();
        };
        var completedPAC = function() {
            screenBlockService.clearScreen();
        };

        //Start Chain of Events
        getCurrentTenant();
    })
    .factory("PACCheckerService", function($rootScope) {
        var pac = {};
        pac.IsPacDone = function() {
            if ($rootScope.PAC && $rootScope.PAC.products && $rootScope.PAC.products.length > 0) {
                return true;
            } else {
                return false;
            }
        };
        pac.GetProductMap = function() {
            return $rootScope.PAC.flatProducts;
        };
        pac.HasProduct = function(productFlatPath) {
            if (pac.IsPacDone() === false) {
                console.log("PAC CHECK PRE-PAC-INIT");
            }

            return _.contains($rootScope.PAC.flatProducts, productFlatPath);
        };
        pac.HasProductFromArray = function(paths) {
            return _.some(paths, pac.HasProduct);
        };

        return pac;
    })
    //UAC = User Access Control - Checks to see if the user has a specific role
    .factory("UACService", function($rootScope, authenticationService) {
        var uac = {};

        uac.hasRole = function(requiredRole) {
            if (authenticationService.isLoggedIn()) {
                var x = _.some(authenticationService.getRoles(), function(r) {
                    return r == requiredRole;
                });
                return x;
            } else {
                return false;
            }
        };

        return uac;
    })
    .directive("pac", function($animate, PACCheckerService) {
        return {
            transclude: "element",
            priority: 600,
            terminal: true,
            restrict: "A",
            link: function($scope, $element, $attr, ctrl, $transclude) {
                var block, childScope, products;

                $attr.$observe("pac", function(value) {
                    products = $scope.$eval(value);
                    if (PACCheckerService.HasProductFromArray(products)) {
                        if (!childScope) {
                            childScope = $scope.$new();
                            $transclude(childScope, function(clone) {
                                block = {
                                    startNode: clone[0],
                                    endNode: (clone[clone.length++] = document.createComment(" end rlnRequireRoles: " + $attr.rlnRequireRoles + " "))
                                };
                                $animate.enter(clone, $element.parent(), $element);
                            });
                        }
                    } else {
                        if (childScope) {
                            childScope.$destroy();
                            childScope = null;
                        }

                        if (block) {
                            $animate.leave(getBlockElements(block));
                            block = null;
                        }
                    }
                });
            }
        };
    })
    .directive("invertedPac", function($animate, PACCheckerService) {
        //Hide Element if customer does have product
        return {
            transclude: "element",
            priority: 600,
            terminal: true,
            restrict: "A",
            link: function($scope, $element, $attr, ctrl, $transclude) {
                var block, childScope, products;

                $attr.$observe("invertedPac", function(value) {
                    products = $scope.$eval(value);
                    if (PACCheckerService.HasProductFromArray(products) === false) {
                        if (!childScope) {
                            childScope = $scope.$new();
                            $transclude(childScope, function(clone) {
                                block = {
                                    startNode: clone[0],
                                    endNode: (clone[clone.length++] = document.createComment(" end rlnRequireRoles: " + $attr.rlnRequireRoles + " "))
                                };
                                $animate.enter(clone, $element.parent(), $element);
                            });
                        }
                    } else {
                        if (childScope) {
                            childScope.$destroy();
                            childScope = null;
                        }

                        if (block) {
                            $animate.leave(getBlockElements(block));
                            block = null;
                        }
                    }
                });
            }
        };
    })
    .directive("uac", function($animate, UACService) {
        return {
            transclude: "element",
            priority: 600,
            terminal: true,
            restrict: "A",
            link: function($scope, $element, $attr, ctrl, $transclude) {
                var block, childScope, role;

                $attr.$observe("uac", function(value) {
                    role = $scope.$eval(value);
                    if (UACService.hasRole(role) === true) {
                        if (!childScope) {
                            childScope = $scope.$new();
                            $transclude(childScope, function(clone) {
                                block = {
                                    startNode: clone[0],
                                    endNode: (clone[clone.length++] = document.createComment(" end rlnRequireRoles: " + $attr.rlnRequireRoles + " "))
                                };
                                $animate.enter(clone, $element.parent(), $element);
                            });
                        }
                    } else {
                        if (childScope) {
                            childScope.$destroy();
                            childScope = null;
                        }

                        if (block) {
                            $animate.leave(getBlockElements(block));
                            block = null;
                        }
                    }
                });
            }
        };
    })
    .controller("BrandController", function($scope, tenantSetupService, $location) {
        // {"TenantId":1,"AuthenticationRelay":null,"BrandIdentity":"fmg"}
        var applyBranding = function() {
            var brand = tenantSetupService.activeSettings.BrandIdentity;

            $scope.loginLogoUrl = "assets/images/" + brand + "-login-logo.png";
            $scope.logoUrl = "assets/images/" + brand + "-logo.png";
            $scope.css = "css/" + brand + ".css";
        };

        if (tenantSetupService.activeSettings) {
            applyBranding();
        } else {
            tenantSetupService.getSettings().then(function(response) {
                tenantSetupService.activeSettings = response.data;
                applyBranding();
            });
        }
    })
    .controller("AuthenticationStatusController", function($scope, authenticationService, $state, app_env) {
        (function oninit() {
            $scope.env = app_env.name;
            $scope.envVersion = app_env.version;
        })();

        $scope.renewToken = function() {
            authenticationService.renewToken().then(function() {
                authenticationService.untilExpire();
            });
        };
        $scope.warnExpire = function() {
            return authenticationService.warnExpire;
        };
        $scope.untilExpire = function() {
            return authenticationService.expires;
        };
        $scope.isLoggedIn = function() {
            var res = authenticationService.isLoggedIn();
            if (res === false && $scope.token) {
                $scope.token = null;
            }
            return res;
        };

        $scope.token = null;
        $scope.displayName = function() {
            if (!$scope.token) {
                $scope.token = authenticationService.getToken();
            }

            return $scope.token.identity.displayName || $scope.token.identity.name;
        };

        $scope.groups = function() {
            return $scope.token.roles;
        };

        $scope.logout = function() {
            $scope.token = null;
            authenticationService.logout();
        };
    })
    .directive("filesInput", function() {
        return {
            require: "ngModel",
            link: function postLink(scope, elem, attrs, ngModel) {
                elem.on("change", function(e) {
                    var files = elem[0].files;
                    ngModel.$setViewValue(files);
                });
            }
        };
    });
